// src/components/Dashboard/SummaryCards.tsx
import React from "react";
import {
  FolderOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

interface SummaryCardsProps {
  data: any;
}

const SummaryCards: React.FC<SummaryCardsProps> = ({ data }) => {
  if (!data) return null;

  const totalFolders = data.total_folders || 0;
  const completedFolders = data.completed_folders || 0;

  const cardItems = [
    {
      title: "Folders Totales",
      value: totalFolders,
      icon: <FolderOutlined className="text-2xl" />,
      color: "bg-blue-100 text-blue-500",
    },
    {
      title: "Folders en Progreso", // Changed from "Active Folders"
      value: data.in_progress_folders || 0, // Changed from activeFolders calculation
      icon: <FileTextOutlined className="text-2xl" />,
      color: "bg-yellow-100 text-yellow-500",
    },
    {
      title: "Folders Completados",
      value: completedFolders,
      icon: <CheckCircleOutlined className="text-2xl" />,
      color: "bg-green-100 text-green-500",
    },
    {
      title: "Multireportes Entregados",
      value: data.multireport_delivered || 0,
      icon: <FileProtectOutlined className="text-2xl" />,
      color: "bg-purple-100 text-purple-500",
    },
    {
      title: "Contratos Generados",
      value: data.lease_contract_generated || 0,
      icon: <FileDoneOutlined className="text-2xl" />,
      color: "bg-pink-100 text-pink-500",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
      {cardItems.map((item, index) => (
        <div key={index} className="bg-white rounded-lg shadow p-4">
          <div className="flex items-start">
            <div className={`rounded-md p-3 ${item.color}`}>{item.icon}</div>
            <div className="ml-4">
              <p className="text-sm text-gray-500">{item.title}</p>
              <p className="text-2xl font-bold">{item.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
